import { IAction } from '~/src/store';

import { ETicketPayment, EValidityStatus } from './index';

export type TSetBonusesAmountValidity = IAction<ETicketPayment.SET_BONUSES_VALIDITY, EValidityStatus>

const setBonusesAmountValidity = (validity: EValidityStatus): TSetBonusesAmountValidity => ({
    type: ETicketPayment.SET_BONUSES_VALIDITY,
    payload: validity,
});

export default setBonusesAmountValidity;
